package com.patronat.top.ui.theme

import androidx.compose.ui.graphics.Color

// ==========================================
// 1. PRIMITIVES (Base Color Palettes)
// ==========================================

// --- Mine Shaft Palette (Grays) ---
val MineShaft50 = Color(0xFFF6F6F6)
val MineShaft100 = Color(0xFFE7E7E7) // Disabled Background/Border
val MineShaft200 = Color(0xFFD1D1D1)          // Default Border
val MineShaft400 = Color(0xFF888888)
val MineShaft500 = Color(0xFF6D6D6D)          // Placeholder Text / Default Text
val MineShaft600 = Color(0xFF5D5D5D) // Disabled/ReadOnly Text
val MineShaft700Strong = Color(0xFF4F4F4F)
val MineShaft900 = Color(0xFF3D3D3D)          // Main Text / Title / Active Text
val MineShaft950 = Color(0xFF2C2C2C) // Button Background

// Temporary Black Button States
internal val MineShaft800 = Color(0xFF424242) // Hover
internal val MineShaft700 = Color(0xFF616161) // Pressed

// --- Primary Palette (Browns) ---
internal val Primary100 = Color(0xFFF2EDE2)   // Active Background / Info Background
internal val Primary200 = Color(0xFFE5D9C3)   // Pressed state
val Primary300          = Color(0xFFD4C09D)
internal val Primary400 = Color(0xFFC4A57B)   // Success Border
internal val Primary500 = Color(0xFFA7784F)   // Default Button Bg
val Primary600          = Color(0xFFA7784F)   // Active Border / Info Text
val Primary700 = Color(0xFF8B6143)
internal val Primary800 = Color(0xFF714F3B)   // Hover state

val SidebarBackground   = Color(0xFFFDF7F2)
val DropdownBorder = Color(0xFFE8E3DD)

// --- Status / Success Palette (Greens) ---
// Додано для статусу "Активний"
internal val Green50  = Color(0xFFE8F5E9)     // Bg
internal val Green200 = Color(0xFFC8E6C9)     // Border
internal val Green800 = Color(0xFF2E7D32)     // Text

// --- Error Palette (Pinks/Reds) ---
val AccentPink = Color(0xFFFF2D55)   // Main Error color
val AccentMint = Color(0xFF00C8B3)
val AccentIndigo = Color(0xFF6155F5)
val AccentOrange = Color(0xFFFF8D28)
val ActiveStatusStroke = Color(0xFF007A55)
internal val Error100 = Color(0xFFFFE5E9)     // Bg Hover
internal val Error500 = AccentPink            // Default

val Error200 = Color(0xFFFECACA)
internal val Error600 = Color(0xFFE02449)     // Hover
internal val Error800 = Color(0xFFC41C3B)     // Pressed

// --- Neutrals ---
val White = Color(0xFFFFFFFF)
val Black = Color(0xFF000000)
internal val Transparent = Color(0x00000000)

// ==========================================
// 2. SEMANTICS (Usage Aliases)
// ==========================================

val AvatarPlaceholderGray = Color(0xFFBDBDBD)

// --- Alerts / System Messages ---
internal val AlertErrorContainer = White
internal val AlertErrorContent = AccentPink
internal val AlertInfoContainer = Primary100
internal val AlertInfoContent = Primary400

// App Global Alert (Top Strip)
val AlertContainer = Color(0xFFE8DFC0)
val AlertAccent = Color(0xFF3C3C3C)
val AlertStrip = Color(0xFF202020)

// --- Input Fields States ---
internal val InputBorderDefault = MineShaft200
internal val InputBorderActive = Primary600
internal val InputBorderError = AccentPink
internal val InputBorderSuccess = Primary400

// --- Status Badges / Dropdowns ---
// Active (Зелений)
val StatusActiveBg = Green50
val StatusActiveContent = Green800
val StatusActiveBorder = Green200

// Inactive (Сірий/Білий)
val StatusInactiveBg = White
val StatusInactiveContent = MineShaft500
val StatusInactiveBorder = MineShaft200

// ==========================================
// --- BUTTON STATES ---
// ==========================================

// 1. Brown Filled (Primary)
internal val ButtonBrownFilledBgDefault = Primary500
internal val ButtonBrownFilledBgHover = Primary800
internal val ButtonBrownFilledBgPressed = Primary200
internal val ButtonBrownFilledBgDisabled = MineShaft500
internal val ButtonBrownFilledContent = MineShaft50

// 2. Brown Outline (Secondary)
internal val ButtonBrownOutlineContentDefault = Primary500
internal val ButtonBrownOutlineContentHover = Primary800
internal val ButtonBrownOutlineContentPressed = Primary200
internal val ButtonBrownOutlineContentDisabled = MineShaft500
internal val ButtonBrownOutlineBorderDisabled = MineShaft100

// 3. Black Filled
internal val ButtonBlackBgDefault = MineShaft950
internal val ButtonBlackBgHover = MineShaft800
internal val ButtonBlackBgPressed = MineShaft700
internal val ButtonBlackBgDisabled = MineShaft500
internal val ButtonBlackContent = White

// 4. Black Outline
internal val ButtonBlackOutlineContent = MineShaft950
internal val ButtonBlackOutlineBorder = MineShaft950
internal val ButtonBlackOutlineBgHover = MineShaft100
internal val ButtonBlackOutlineBgPressed = MineShaft200

// 5. Error Filled
internal val ButtonErrorBgDefault = Error500
internal val ButtonErrorBgHover = Error600
internal val ButtonErrorBgPressed = Error800
internal val ButtonErrorBgDisabled = MineShaft500
internal val ButtonErrorContent = White

// 6. Error Outline
internal val ButtonErrorOutlineContent = Error500
internal val ButtonErrorOutlineBorder = Error500
internal val ButtonErrorOutlineBgHover = Error100
internal val ButtonErrorOutlineBgPressed = Color(0xFFFFD1D8)

val SearchBackground = Color(0xFFF5F5F5)
val SearchBorderActive = Color(0xFF8B6D46)
val SearchBorderInactive = Color(0xFFE0E0E0)
val TextHint = Color(0xFF9E9E9E)
